export default "__VITE_ASSET__C31r8RLL__"